import { Helmet } from 'react-helmet-async';

interface StructuredDataProps {
  type?: 'organization' | 'service' | 'localbusiness';
  data?: Record<string, any>;
}

const StructuredData = ({ type = 'organization', data }: StructuredDataProps) => {
  const getStructuredData = () => {
    const baseOrganization = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Organize by Design Michigan",
      "description": "Professional home organization services in Southwest Michigan specializing in housekeeping systems, real estate prep, and ADHD-friendly organizing. Serving Buchanan, Niles, St. Joseph & surrounding areas.",
      "url": "https://organizebydesign.lovable.app",
      "telephone": "+1-616-727-0343",
      "email": "hello@organizebydesignmichigan.com",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "Michigan",
        "addressCountry": "US"
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Buchanan",
          "addressRegion": "Michigan"
        },
        {
          "@type": "City", 
          "name": "Niles",
          "addressRegion": "Michigan"
        },
        {
          "@type": "City",
          "name": "St. Joseph", 
          "addressRegion": "Michigan"
        }
      ],
      "priceRange": "$500-$7000+",
      "serviceType": [
        "Housekeeping Organization",
        "Real Estate Prep & Staging", 
        "ADHD Organizing Systems",
        "Home Decluttering",
        "Same-Day Emergency Organization"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Home Organization Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Housekeeping Organization Systems",
              "description": "Daily routine optimization and maintenance systems for Michigan homes"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "Service",
              "name": "ADHD Organization Systems",
              "description": "Neurodivergent-friendly organization solutions"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service", 
              "name": "Real Estate Prep & Staging",
              "description": "Home staging and organization for faster sales"
            }
          }
        ]
      }
    };

    if (type === 'service' && data) {
      return {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": data.name,
        "description": data.description,
        "provider": baseOrganization,
        "areaServed": baseOrganization.areaServed,
        "offers": {
          "@type": "Offer",
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock"
        }
      };
    }

    return baseOrganization;
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(getStructuredData())}
      </script>
    </Helmet>
  );
};

export default StructuredData;